/**
 * 「当前正在看的客户」。**只为 AI 助手存在。**
 *
 * 助手是个悬浮面板,飘在所有屏之上;而「这个客户进展到哪了」这种问题
 * 只有知道你正在看谁才答得出来。用一个二十行的订阅点足够了 ——
 * 为这件事引一个状态库,是拿一套抽象换一个变量。
 *
 * 详情页挂载时写、卸载时清:写了不清的话,你关掉详情回到主页再问助手,
 * 它还在回答上一个客户的事,而你不会发现。
 */
let current: { id: string; name: string } | undefined;
const listeners = new Set<() => void>();

export function setCurrentCustomer(c: { id: string; name: string } | undefined): void {
  current = c;
  for (const l of listeners) l();
}

export function getCurrentCustomer(): { id: string; name: string } | undefined {
  return current;
}

export function subscribeCurrentCustomer(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
